// custom typefaces
// import "typeface-montserrat"
import "prismjs/themes/prism-tomorrow.css"

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
    if (location.state && location.state.preventScroll === true) {
        return false;
    }

    if (location.hash) {
        window.history.scrollRestoration = 'auto';
        return true;
    }

    window.history.scrollRestoration = 'manual';

    const currentPosition = getSavedScrollPosition(location, location.key);
    const top = currentPosition ? currentPosition[1] : 0;

    window.setTimeout(() => {
        window.requestAnimationFrame(() => {
            try {
                window.scrollTo({ top, behavior: 'instant' });
            } catch (e) {
                window.scrollTo(top);
            }
        });
    }, 0);

    return false;
};